import "./mobile-widget/mobile-widget.css"
import React, { useState, useEffect, useRef } from "react";
import { Col, Button, Accordion, Modal, Row, Form, Spinner } from "react-bootstrap";
import WidgetForm, { DatesAndGuests } from "../widget-form/WidgetForm";

import RequestQuoteModal from "./widget-modals/RequestQuoteModal";
import FindReservation from "./widget-modals/FindReservationModal";
import MobileWidget from "./mobile-widget/MobileWidget";

import UseGetStartWidget, { GetStartWidgetRequest, GetStartWidgetResponse } from "./data-service-hooks/UseGetStartWidget";
import UseGetWidgetStyle, { GetStyleRequest, GetStyleResponse } from "./data-service-hooks/UseGetWidgetStyle";
import UseGetBrands, { GetBrandsRequest, GetBrandsResponse } from "./data-service-hooks/UseGetBrands";

import ItineraryStart from "./itinerary/ItineraryStart";
import LodgingItem from "../../../../Data/LodgingItem";
import GolfItem from "../../../../Data/GolfItem";
import TransportItem from "../../../../Data/TransportItem";
import CustomItem from "../../../../Data/CustomItem";
// import VendorUnit from "../../../../Data/VendorUnit";

import LodgingItinerary from "../../../../Data/Reservation/Lodging/LodgingItinerary";
import GolfItinerary from "../../../../Data/Reservation/Golf/GolfItinerary";
import TransportItinerary from "../../../../Data/Reservation/Transportation/TransportItinerary";
import CustomItinerary from "../../../../Data/Reservation/Custom/CustomItinerary";
import Itinerary from "../../../../Data/Itinerary";
import AddCustomModal from "./widget-modals/custom/add-custom/AddCustomModal";
import LodgingItineraryUnit from "../../../../Data/Reservation/Lodging/LodgingItineraryUnit";
import StartWidget from "../../../../Data/StartWidget";
import GolfItineraryUnit from "../../../../Data/Reservation/Golf/GolfItineraryUnit";
import TransportItineraryUnit from "../../../../Data/Reservation/Transportation/TransportItineraryUnit";
import CustomItineraryUnit from "../../../../Data/Reservation/Custom/CustomItineraryUnit";
import WidgetStyle from "../../../../Data/WidgetStyle";
import VendorUnit from "../../../../Data/VendorUnit";
import { Constants } from "../../../../_helpers/Constants";
import useWindowSize from "../../../../_helpers/UseWindowHook";
import { WidgetContext } from "../../../../context/WidgetContext";
import ViewPort from "../../../../_helpers/Enums/ViewPortEnum";
import AddGolfModal from "./widget-modals/golf/add-golf/AddGolfModal";
import AddLodgingModal from "./widget-modals/lodging/add-lodging/AddLodgingModal";
import AddTransportModal from "./widget-modals/transportation/add-transportation/AddTransportModal";
// import GetQuote from "./itinerary/get-quote/GetQuote";
import Quote from "../../../../Data/Quote/Quote";
// import MakePayment from "./itinerary/make-payment/MakePayment";
import FindReservationModal from "./widget-modals/FindReservationModal";
import AddPreBuiltPackageModal from "./widget-modals/pre-built-packages/add-packages/AddPreBuiltPackageModal";
import UseGetCustomVendors, { GetCustomVendorsRequest, GetCustomVendorsResponse } from "./widget-modals/custom/add-custom/data-service-hooks/UseGetCustomVendors";
import UseGetGolfVendors, { GetGolfVendorsRequest, GetGolfVendorsResponse } from "./widget-modals/golf/add-golf/data-service-hooks/UseGetGolfVendors";
import UseGetLodgingVendors, { GetLodgingVendorsRequest, GetLodgingVendorsResponse } from "./widget-modals/lodging/add-lodging/data-service-hooks/UseGetLodgingVendors";
import UseGetTransportVendors, { GetTransportVendorsRequest, GetTransportVendorsResponse } from "./widget-modals/transportation/add-transportation/data-service-hooks/UseGetTransportVendors";
import Reservation from "../../../../Data/Reservation/Reservation";
import useSearchQuote, { SearchQuoteRequest, SearchQuoteResponse } from "./data-service-hooks/UseSearchQuote";
import { ReservationCustomer } from "../../../../Data/Reservation/ReservationCustomer";
import Decimal from "decimal.js";
import moment from "moment";
import useCreateIndividualCategory, { CreateIndividualCategoryRequest } from "./data-service-hooks/UseCreateIndividualCategory";
import { isStringEmpty, ObjToQueryString } from "../../../../_helpers/Functions";
import ReactGA from 'react-ga4';
import useCalculateWidgetHeight from "../../../../_helpers/UseCalculateWidgetHeight";
import UseGetVendorTypeByGuid, { GetVendorTypeByGuidRequest } from "./data-service-hooks/UseGetVendorTypeByGuid";
import UseGetPackages, { GetPackagesRequest, GetPackagesResponse } from "./widget-modals/pre-built-packages/add-packages/data-service-hooks/UseGetPreBuiltPackages";
import PackagesCard from "./widget-modals/pre-built-packages/packages-card/PackagesCard";
import PackageDetails from "./widget-modals/pre-built-packages/package-details/PackageDetails";
import PackageDetailsModal from "./widget-modals/pre-built-packages/package-details/PackageDetailsModal";
import useFetch, { FetchRequest } from "../../../../_helpers/UseFetchHook";
import { TimeOption } from "../../../../_helpers/Types";
import { PreBuiltPkg } from "./widget-modals/pre-built-packages/Models/PreBuiltPkg";
import UseGetQuickPackages, { GetQuickPackagesRequest, GetQuickPackagesResponse } from "./widget-modals/pre-built-packages/add-packages/data-service-hooks/UseGetQuickPackages";
import UseGetPackageById, { GetPackageByIdRequest, GetPackageByIdResponse } from "./widget-modals/pre-built-packages/add-packages/data-service-hooks/UseGetPackageById";
import MobileHamburgerMenu from "./mobile-widget/MobileHamburgerMenu";
import StartWidgetBrand from "../../../../Data/StartWidgetBrand";
import StartWidgetBrandSetting from "../../../../Data/StartWidgetBrandSetting";

interface props {
  startWidgetId: number;
  itineraryNumber: string | undefined;
  customerId: number | undefined;
  autoScroll: boolean;
  vendorGuid: string | undefined;
  campaignId: string | undefined;
  packageParam: string | undefined;
}

// the main object that ties all the information together
const Widget: React.FC<props> = (props) => {
  const { startWidgetId, itineraryNumber, customerId, autoScroll, campaignId, packageParam } = props;
  const [fromEmail, setFromEmail] = useState(itineraryNumber != undefined);

  const { width, height, breakPoint } = useWindowSize();
  const [startWidget, setStartWidget] = useState<StartWidget>();
  // Fetch Start Widget
  const [getWidgetRequest, setGetWidgetRequest] = useState<GetStartWidgetRequest>();
  const responseGetWidget = UseGetStartWidget(getWidgetRequest);

  const [style, setStyle] = useState<WidgetStyle>();
  const [getStyleRequest, setGetStyleRequest] = useState<GetStyleRequest>();
  const responseGetStyle = UseGetWidgetStyle(getStyleRequest);

  const [getVendorTypeByGuidRequest, setGetVendorTypeByGuidRequest] = useState<GetVendorTypeByGuidRequest>();
  const responseGetVendorType = UseGetVendorTypeByGuid(getVendorTypeByGuidRequest);
  const [vendorGuidType, setVendorGuidType] = useState<string>();

  const [brands, setBrands] = useState<StartWidgetBrand[]>([]);
  const [brandId, setBrandId] = useState<number>(-1);
  const [companyId, setCompanyId] = useState<number | undefined>();
  const [brandSettings, setBrandSettings] = useState<StartWidgetBrandSetting[]>([]);
  const [getBrandsRequest, setGetBrandsRequest] = useState<GetBrandsRequest>();
  const responseGetBrands = UseGetBrands(getBrandsRequest);

  const [brand, setBrand] = useState<StartWidgetBrand>();

  const [show, setShow] = useState("build-your-own");
  const [validated, setValidated] = useState(false);

  const [quote, setQuote] = useState<Quote>();
  const [quoteSearchRequest, setQuoteSearchRequest] = useState<SearchQuoteRequest>();
  const quoteSearchResponse = useSearchQuote(quoteSearchRequest);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [itinerary, setItinerary] = useState<Itinerary>({});
  const [emailCustomer, setEmailCustomer] = useState<ReservationCustomer>();
  const itineraryNotEmpty = Object.keys(itinerary).length > 0 && Object.keys(itinerary).some(key => itinerary[key] != undefined);

  const [lodgingItemToEdit, setLodgingItemToEdit] = useState<LodgingItineraryUnit | undefined>();
  const [golfItemToEdit, setGolfItemToEdit] = useState<GolfItineraryUnit | undefined>();
  const [transportItemToEdit, setTransportItemToEdit] = useState<TransportItineraryUnit | undefined>();
  const [customItemToEdit, setCustomItemToEdit] = useState<CustomItineraryUnit | undefined>();

  const [lodgingVendors, setLodgingVendors] = useState<any>();
  const [getLodgingVendorsRequest, setGetLodgingVendorsRequest] = useState<GetLodgingVendorsRequest>();
  const responseGetLodgingVendors = UseGetLodgingVendors(getLodgingVendorsRequest);

  const [golfVendors, setGolfVendors] = useState<any>();
  const [getGolfVendorsRequest, setGetGolfVendorsRequest] = useState<GetGolfVendorsRequest>();
  const responseGetGolfVendors = UseGetGolfVendors(getGolfVendorsRequest);

  const [transportVendors, setTransportVendors] = useState<any>();
  const [getTransportVendorsRequest, setGetTransportVendorsRequest] = useState<GetTransportVendorsRequest>();
  const responseGetTransportVendors = UseGetTransportVendors(getTransportVendorsRequest);

  const [customVendors, setCustomVendors] = useState<any>();
  const [getCustomVendorsRequest, setGetCustomVendorsRequest] = useState<GetCustomVendorsRequest>();
  const responseGetCustomVendors = UseGetCustomVendors(getCustomVendorsRequest);

  const startingDate = Constants.startingDate;
  const threeDaysFromStart = Constants.threeDaysFromStartingDate;
  const [datesAndGuests, setDatesAndGuests] = useState<DatesAndGuests>({
    fromDate: startingDate,
    toDate: threeDaysFromStart,
    fromTime: undefined,
    toTime: undefined,
    guests: 2,
    units: 1
  });

  const [getQuickPackagesRequest, setGetQuickPackagesRequest] = useState<GetQuickPackagesRequest>();
  const responseGetQuickPackages = UseGetQuickPackages(getQuickPackagesRequest);
  const [packages, setPackages] = useState<any[]>([]);

  const [getPackageParamRequest, setGetPackageParamRequest] = useState<GetPackageByIdRequest>();
  const getPackageByIdResponse = UseGetPackageById(getPackageParamRequest);
  const [packageFromParam, setPackageFromParam] = useState<PreBuiltPkg>();

  const { sendItineraryUnitsMessage } = useCalculateWidgetHeight(
    startWidget,
    itinerary,
    autoScroll,
    show,
    undefined,
    (quote && quote.reservation.statusId && (Number)(quote.reservation.statusId) !== 40 && (Number)(quote.reservation.statusId) !== 50)
  );

  const [importedPackage, setImportedPackage] = useState<PreBuiltPkg>();

  /*******************************************/

  function addSelectedLodging(item: LodgingItem, index?: number) {
    const lodgingItineraries = itinerary.lodgingItineraries || [];
    let lodgingItinerary = lodgingItineraries.find((i: LodgingItinerary) => i.vendorId == item.vendorId);
    if (lodgingItinerary == undefined) {
      lodgingItinerary = {
        vendorId: item.vendorId,
        vendor: item,
        useLocalRates: item.useLocalRates,
        fees: 0.0,
        itineraryUnits: []
      }

      itinerary.lodgingItineraries = [...lodgingItineraries, lodgingItinerary];
    }

    // if index not undefined cut out the correct index then recreate the item
    if (index !== undefined && index > -1) {
      let itineraryIndex = -1;
      lodgingItinerary.itineraryUnits.forEach((unit, i) => {
        if ((unit.itineraryIndex as number) === index)
          itineraryIndex = i;
      });

      if (itineraryIndex > -1)
        lodgingItinerary.itineraryUnits.splice(itineraryIndex, 1);
    }

    // console.log("vendorUnitId", item.selectedUnit);

    const itineraryUnit: LodgingItineraryUnit = {
      vendorUnitId: item.selectedUnit ? item.selectedUnit.vendorUnitId : 0,
      vendorId: item.vendorId,
      vendor: item,
      startDate: moment(new Date(item.startDate)).format("YYYY-MM-DD"),
      endDate: moment(new Date(item.endDate)).format("YYYY-MM-DD"),
      startTime: "",
      endTime: "",
      numberOfGuests: item.numberOfGuests,
      numberOfUnits: Math.max(item.numberOfUnits, Math.ceil(item.numberOfGuests / (item.selectedUnit?.personPerUnit || 32))),
      sell: item.selectedUnit ? item.selectedUnit.sell : 0.0,
      cost: 0.0,
      profit: 0.0,
      tax1: 0.0,
      tax2: 0.0,
      resortFee: 0.0,
      cleaningFee: 0.0,
      showOnItinerary: true,
      overrideRate: false,
      liveRate: item.selectedUnit?.isLive || false,
      itineraryIndex: lodgingItineraries.flatMap(i => i.itineraryUnits).length,
      cancelled: false,
      unitName: !!item.selectedUnit ? item.selectedUnit.unitName : "",
      travelPortRateName: item.travelPortRateName,
      preBuiltPkgVendorUnit: item.preBuiltPkgVendorUnit,
      availableTimes: []
    }

    lodgingItinerary.itineraryUnits.push(itineraryUnit);
    setItinerary({ ...itinerary });
  }

  function addSelectedGolf(item: GolfItem, index?: number) {
    const golfItineraries = itinerary.golfItineraries || [];
    let golfItinerary = golfItineraries.find((i: GolfItinerary) => i.vendorId == item.vendorId);
    if (golfItinerary == undefined) {
      golfItinerary = {
        vendorId: item.vendorId,
        vendor: item,
        useLocalRates: true,
        fees: 0.0,
        itineraryUnits: []
      }

      itinerary.golfItineraries = [...golfItineraries, golfItinerary];
    }

    if (index !== undefined && index > -1) {
      let itineraryIndex = -1;
      golfItinerary.itineraryUnits.forEach((unit, i) => {
        if ((unit.itineraryIndex as number) === index)
          itineraryIndex = i;
      });

      if (itineraryIndex > -1)
        golfItinerary.itineraryUnits.splice(itineraryIndex, 1);
    }

    let playerCount = item.numberOfGuests;
    let timeIndex = item.availableTimes.findIndex(t => t.value === item.startTime);
    let sell = item.selectedUnit ? item.selectedUnit.sell : 0.0;
    const players = timeIndex > -1 ? Math.min(item.preBuiltPkgVendorUnit === undefined ?
      item.availableTimes[timeIndex].openSpots : Math.min(item.preBuiltPkgVendorUnit.toGuests, item.availableTimes[timeIndex].openSpots), playerCount) : item.numberOfGuests;

    do {
      const itineraryUnit: GolfItineraryUnit = {
        vendorUnitId: item.selectedUnit ? item.selectedUnit.vendorUnitId : 0,
        vendorId: item.vendorId,
        vendor: item,
        numberOfGuests: players,
        numberOfUnits: players,
        startDate: moment(item.startDate).format("YYYY-MM-DD"),
        endDate: moment(item.startDate).format("YYYY-MM-DD"),
        startTime: item.startTime,
        endTime: item.startTime,
        sell: sell,
        cost: 0.0,
        profit: 0.0,
        tax1: 0.0,
        tax2: 0.0,
        resortFee: 0.0,
        cleaningFee: 0.0,
        showOnItinerary: true,
        overrideRate: false,
        itineraryIndex: golfItinerary.itineraryUnits.length,
        cancelled: false,
        productRateId: item.productRateId,
        foreUpTeeTimeId: item.foreUpTeeTimeId,
        golfNowTeeTimeId: item.golfNowTeeTimeId,
        availableTimes: item.availableTimes,
        liveRate: !isStringEmpty(item.foreUpTeeTimeId) || !isStringEmpty(item.golfNowTeeTimeId) || !isStringEmpty(item.lightSpeedTeeTimeId),
        unitName: !!item.selectedUnit ? item.selectedUnit.unitName : "",
        preBuiltPkgVendorUnit: item.preBuiltPkgVendorUnit
      }

      golfItinerary.itineraryUnits.push(itineraryUnit);

      playerCount -= timeIndex > -1 ? Math.min(item.preBuiltPkgVendorUnit === undefined ?
        item.availableTimes[timeIndex].openSpots : Math.min(item.preBuiltPkgVendorUnit.toGuests, item.availableTimes[timeIndex].openSpots), playerCount) : item.numberOfGuests;

      if (playerCount > 0 && timeIndex + 1 < item.availableTimes.length) {
        item.startTime = item.availableTimes[timeIndex + 1].value;
        item.foreUpTeeTimeId = item.availableTimes[timeIndex + 1].foreUpTeeTimeId;
        item.golfNowTeeTimeId = item.availableTimes[timeIndex + 1].golfNowTeeTimeId;
        item.lightSpeedTeeTimeId = item.availableTimes[timeIndex + 1].lightSpeedTeeTimeId;
        sell = item.availableTimes[timeIndex + 1].price * playerCount;
        timeIndex += 1;
      }
    } while (playerCount > 0);

    setItinerary({ ...itinerary });
  }

  function addSelectedTransportation(item: TransportItem, index?: number) {
    const transportItineraries = itinerary.transportItineraries || [];
    let transportItinerary = transportItineraries.find((i: TransportItinerary) => i.vendorId == item.vendorId);
    if (transportItinerary == undefined) {
      transportItinerary = {
        vendorId: item.vendorId,
        vendor: item,
        useLocalRates: true,
        fees: 0.0,
        itineraryUnits: []
      }

      itinerary.transportItineraries = [...transportItineraries, transportItinerary];
    }

    if (index !== undefined && index > -1) {
      let itineraryIndex = -1;
      transportItinerary.itineraryUnits.forEach((unit, i) => {
        if ((unit.itineraryIndex as number) === index)
          itineraryIndex = i;
      });

      if (itineraryIndex > -1)
        transportItinerary.itineraryUnits.splice(itineraryIndex, 1);
    }

    const itineraryUnit: TransportItineraryUnit = {
      vendorUnitId: item.selectedUnit ? item.selectedUnit.vendorUnitId : 0,
      vendorId: item.vendorId,
      vendor: item,
      startDate: moment(item.startDate).format("YYYY-MM-DD"),
      endDate: moment(item.endDate).format("YYYY-MM-DD"),
      startTime: item.startTime ?? "",
      endTime: item.endTime ?? "",
      numberOfUnits: item.numberOfUnits,
      numberOfGuests: item.numberOfGuests,
      sell: item.selectedUnit ? item.selectedUnit.sell : 0.0,
      cost: 0.0,
      profit: 0.0,
      tax1: 0.0,
      tax2: 0.0,
      resortFee: 0.0,
      cleaningFee: 0.0,
      showOnItinerary: true,
      overrideRate: false,
      liveRate: false,
      itineraryIndex: transportItinerary.itineraryUnits.length,
      cancelled: false,
      unitName: !!item.selectedUnit ? item.selectedUnit.unitName : "",
      availableTimes: []
    }

    transportItinerary.itineraryUnits.push(itineraryUnit);
    setItinerary({ ...itinerary });
  }

  function addSelectedCustom(item: CustomItem, index?: number) {
    const customItineraries = itinerary.customItineraries || [];
    let customItinerary = customItineraries.find((i: CustomItinerary) => i.vendorId == item.vendorId);
    if (customItinerary == undefined) {
      customItinerary = {
        vendorId: item.vendorId,
        vendor: item,
        useLocalRates: true,
        fees: 0.0,
        itineraryUnits: []
      }

      itinerary.customItineraries = [...customItineraries, customItinerary];
    }

    if (index !== undefined && index > -1) {
      let itineraryIndex = -1;
      customItinerary.itineraryUnits.forEach((unit, i) => {
        if ((unit.itineraryIndex as number) === index)
          itineraryIndex = i;
      });

      if (itineraryIndex > -1)
        customItinerary.itineraryUnits.splice(itineraryIndex, 1);
    }

    const itineraryUnit: CustomItineraryUnit = {
      vendorUnitId: item.selectedUnit ? item.selectedUnit.vendorUnitId : 0,
      vendorId: item.vendorId,
      vendor: item,
      startDate: moment(item.startDate).format("YYYY-MM-DD"),
      endDate: moment(item.endDate).format("YYYY-MM-DD"),
      startTime: item.startTime ?? "",
      endTime: item.endTime ?? "",
      numberOfGuests: item.numberOfGuests,
      numberOfUnits: item.numberOfUnits,
      sell: item.selectedUnit ? item.selectedUnit.sell : 0.0,
      cost: 0.0,
      profit: 0.0,
      tax1: 0.0,
      tax2: 0.0,
      resortFee: 0.0,
      cleaningFee: 0.0,
      showOnItinerary: true,
      overrideRate: false,
      liveRate: false,
      itineraryIndex: customItinerary.itineraryUnits.length,
      cancelled: false,
      unitName: !!item.selectedUnit ? item.selectedUnit.unitName : "",
      availableTimes: []
    }

    customItinerary.itineraryUnits.push(itineraryUnit);
    setItinerary({ ...itinerary });
  }

/*******************************************/
  
  // useEffect(() => {
  //   console.log("build ver 1");
  // }, []);

  useEffect(() => {
    setGetWidgetRequest({
      widgetId: startWidgetId,
    });
  }, []);

  useEffect(() => {
    if (!!!responseGetWidget.data) return;

    const startWidget: StartWidget = responseGetWidget.data;

    setStartWidget(startWidget)

    if (startWidget.activateGoogleAnalytics && !isStringEmpty(startWidget.googleAnalyticsTrackingCode)) {
      ReactGA.initialize(startWidget.googleAnalyticsTrackingCode, {
        gaOptions: {
          cookieFlags: 'secure;samesite=none',
        }
      });
    }
  }, [responseGetWidget.data]);

  useEffect(() => {
    setGetStyleRequest({
      widgetId: startWidgetId,
    });
  }, []);

  useEffect(() => {
    if (!!!responseGetStyle.data) return;
      const responseData: GetStyleResponse = responseGetStyle.data;

      setStyle(responseData.widgetStyle);
  }, [responseGetStyle.data]);

  useEffect(() => {
    setGetBrandsRequest({
      widgetId: startWidgetId,
    });
  }, []);

  useEffect(() => {
    if (brands === undefined || brands === null || brands.length === 0) return;

    setBrandId(brands[0].brandId);
  }, [brands]);

  useEffect(() => {
    if (responseGetBrands.data) {
      const responseData: GetBrandsResponse = responseGetBrands.data;

      const settings = responseData.brandsSettings;
      const brands = responseData.widgetBrands.map((b: any) => {
        const setting = settings.find((s: any) => s.brandId === b.brandId);
        return { ...b, webOrder: setting?.brand.webOrder };
      });

      setBrands(brands);
      // setBrandId(brands.length > 1 ? undefined : brands[0].brandId);
      setBrandSettings(settings);
    }
  }, [responseGetBrands.data]);

  useEffect(() => {
    if (!fromEmail || itineraryNumber === undefined) return;
    // get the reservation and the customer
    setQuoteSearchRequest({ email: "", itineraryNumber: `${itineraryNumber}` });
  }, []);

  useEffect(() => {
    if (quoteSearchResponse.data) {
      // console.log("quoteSearchResponse", quoteSearchResponse);
      const response: SearchQuoteResponse = quoteSearchResponse.data;

      response.reservation.lodgingItineraries.forEach((i: any) => {
        if (i.vendor) {
          // i.vendor.dailyRates = undefined;
          i.itineraryUnits.forEach((u: any) => {
            if (isStringEmpty(u.startDate)) u.startDate = u.checkIn;
            if (isStringEmpty(u.endDate)) u.endDate = u.checkOut;
            if (u.numberOfGuests === 0) u.numberOfGuests = u.guestsInUnit;
            if (u.numberOfUnits === 0) u.numberOfUnits = u.units;
            // u.vendorType = "Lodging";
          });
        };
      });

      response.reservation.golfItineraries.forEach((i: any) => {
        if (i.vendor) {
          // i.vendor.dailyRates = undefined;
          i.itineraryUnits.forEach((u: any) => {
            if (isStringEmpty(u.startDate)) u.startDate = u.playDate;
            if (isStringEmpty(u.endDate)) u.endDate = u.playDate;
            if (isStringEmpty(u.startTime)) u.startTime = u.teeTime || "";
            if (isStringEmpty(u.endTime)) u.endTime = u.teeTime || "";
            if (u.numberOfGuests === 0) u.numberOfGuests = u.players;
            if (u.numberOfUnits === 0) u.numberOfUnits = u.players;
            // u.vendorType = "Golf";
          });
        };
      });

      response.reservation.transportItineraries.forEach((i: any) => {
        if (i.vendor) {
          // i.vendor.dailyRates = undefined;
          i.itineraryUnits.forEach((u: any) => {
            if (u.numberOfGuests === 0) u.numberOfGuests = u.guestsInUnit;
            if (u.numberOfUnits === 0) u.numberOfUnits = u.units;
            // u.vendorType = "Transport";
          });
        };
      });

      response.reservation.customItineraries.forEach((i: any) => {
        if (i.vendor) {
          // i.vendor.dailyRates = undefined;
          i.itineraryUnits.forEach((u: any) => {
            if (isStringEmpty(u.startDate)) u.startDate = u.fromDate;
            if (isStringEmpty(u.endDate)) u.endDate = u.toDate;
            if (isStringEmpty(u.startTime)) u.startTime = u.fromTime;
            if (isStringEmpty(u.endTime)) u.endTime = u.toTime;
            if (u.numberOfGuests === 0) u.numberOfGuests = u.guestsInUnit;
            if (u.numberOfUnits === 0) u.numberOfUnits = u.units;
            // u.vendorType = "Custom";
          });
        };
      });

      let _quote: Quote = response.quote == undefined ? {
        reservation: response.reservation,
        requestNote: ""
      } : response.quote;

      _quote.reservation = response.reservation;

      // console.log("quote", _quote);

      setFromEmail(true);
      setBrandId(_quote.reservation.brandId === undefined ? -1 : _quote.reservation.brandId as number);

      if (_quote.reservation.lodgingItineraries && _quote.reservation.lodgingItineraries.length > 0) {
        _quote.reservation.lodgingItineraries.forEach(i => i.itineraryUnits.forEach(u => {
          u.vendor = i.vendor;
        }));
        itinerary.lodgingItineraries = _quote.reservation.lodgingItineraries;
      }

      if (_quote.reservation.golfItineraries && _quote.reservation.golfItineraries.length > 0) {
        _quote.reservation.golfItineraries.forEach(i => i.itineraryUnits.forEach(u => {
          u.vendor = i.vendor;
        }));
        itinerary.golfItineraries = _quote.reservation.golfItineraries;
      }

      if (_quote.reservation.transportItineraries && _quote.reservation.transportItineraries.length > 0) {
        _quote.reservation.transportItineraries.forEach(i => i.itineraryUnits.forEach(u => {
          u.vendor = i.vendor;
        }));
        itinerary.transportItineraries = _quote.reservation.transportItineraries;
      }

      if (_quote.reservation.customItineraries && _quote.reservation.customItineraries.length > 0) {
        _quote.reservation.customItineraries.forEach(i => i.itineraryUnits.forEach(u => {
          u.vendor = i.vendor;
        }));
        itinerary.customItineraries = _quote.reservation.customItineraries;
      }

      itinerary.adjustments = _quote.reservation.adjustments;
      _quote.reservation.reservationCustomers = _quote.reservation.reservationCustomers.sort((a: any, b: any) => {
        if (a.customerId === _quote.reservation.leadCustomerId && b.customerId !== _quote.reservation.leadCustomerId) return -1;
        if (a.customerId !== _quote.reservation.leadCustomerId && b.customerId === _quote.reservation.leadCustomerId) return 1;

        if (!a.cancelled && b.cancelled) return -1;
        if (a.cancelled && !b.cancelled) return 1;

        return 0;
      });

      setQuote(_quote);
      setItinerary({ ...itinerary });

      if (customerId) {
        const customer = _quote.reservation.reservationCustomers.find(c => c.customerId == customerId);
        setEmailCustomer(customer);
      }

      setDatesAndGuests({
        fromDate: moment(_quote.reservation.arrive).toDate(),
        toDate: moment(_quote.reservation.depart).toDate(),
        guests: Math.max(_quote.reservation.numGuests, _quote.reservation.reservationCustomers.filter(rc => !rc.cancelled).length),
        units: 1,
      });
    }
  }, [quoteSearchResponse.data]);

  useEffect(() => {
    if (quote) {
      setBrandId(quote.reservation.brandId === undefined ? -1 : quote.reservation.brandId);
    }
  }, [quote]);

  useEffect(() => {
    setIsLoading(responseGetWidget.isLoading || responseGetStyle.isLoading || responseGetBrands.isLoading || quoteSearchResponse.isLoading);
  }, [responseGetWidget.isLoading, responseGetStyle.isLoading, responseGetBrands.isLoading, quoteSearchResponse.isLoading]);

  useEffect(() => {
    if (isLoading || isStringEmpty(packageParam) || packageParam === undefined) return;

    let fromDateString = datesAndGuests.fromDate ? datesAndGuests.fromDate.toLocaleDateString("en-US").replace("/", "-") : "";
    fromDateString = fromDateString.replace("/", "-");
    let toDateString = datesAndGuests.toDate ? datesAndGuests.toDate.toLocaleDateString("en-US").replace("/", "-") : "";
    toDateString = toDateString.replace("/", "-");

    setGetPackageParamRequest({ packageId: +packageParam, startDate: fromDateString, endDate: toDateString });
  }, [packageParam, isLoading]);

  /****************************************** */

  // Import Pre Built Packages
  // useEffect(() => {
  //   if (importedPackage === undefined || brandId === undefined || brandId === -1) return;

  // }, [importedPackage]);

  const [calculateRateRequest, setCalculateRateRequest] = useState<FetchRequest>();
  const calculateRateResponse = useFetch(calculateRateRequest);

  const [loadingPackage, setLoadingPackage] = useState<boolean>(false);

  useEffect(() => {
    if (importedPackage /*&& reservationData.current.preBuiltPkgId === undefined*/) {
      setLoadingPackage(true);
      populateFromImportedPackage();
    }
  }, [importedPackage]);

  // useEffect(() => {
  //   console.log("loadingPackage", loadingPackage);
  // }, [loadingPackage]);


  function populateFromImportedPackage() {
    if (importedPackage === undefined) return;

    // console.log("importedPackage", importedPackage);

    const vendorIds = importedPackage.preBuiltPkgVendors.map((v: any) => v.vendorId);
    let fromDateString = datesAndGuests.fromDate ? datesAndGuests.fromDate.toLocaleDateString("en-US").replace("/", "-") : "";
    fromDateString = fromDateString.replace("/", "-");
    let toDateString = datesAndGuests.toDate ? datesAndGuests.toDate.toLocaleDateString("en-US").replace("/", "-") : "";
    toDateString = toDateString.replace("/", "-");

    const query = ObjToQueryString({
      brandId: brandId,
      startDate: fromDateString,
      endDate: toDateString,
      vendorIds: vendorIds.join(","),
    });

    setCalculateRateRequest({
      url: `${Constants.apiUrl}/api/v1.0/customer-portal/get/rates?${query}`,
      method: 'GET',
    });
  }

  // this gets called when importing a pre built package
  useEffect(() => {
    if (!!!calculateRateResponse.data || !!!importedPackage) return;

    // calculateRateResponse.data is an array of VendorDtos
    const vendors = calculateRateResponse.data;
    // console.log("importedPackage", importedPackage);
    let golfCount = 0;
    for (let index = 0; index < vendors.length; index++) {
      const pbVendor = importedPackage?.preBuiltPkgVendors.find((v: any) => v.vendorId === vendors[index].vendorId);
      // console.log("pbVendor", pbVendor);

      pbVendor?.preBuiltPkgVendorUnits.forEach((pbUnit: any, i: number) => {
        const selectedUnitName = pbUnit.vendorUnit?.unitName;
        const outerRate = vendors[index].dailyRates[0].unitRates.find((r: any) => r.vendorUnitDisplayName === selectedUnitName);

        if (outerRate !== undefined) {
          if (vendors[index].vendorType === "Lodging") {
            const rate = outerRate.rates[0];

            const selectedTravePortUnitName = null;
            const selectedTravePortLodgingOfferId = null;

            let selection: LodgingItem = { ...vendors[index] };
            selection.vendor = vendors[index];
            selection.vendorUnitId = rate.vendorUnitId;
            selection.startDate = datesAndGuests.fromDate.toDateString();
            selection.endDate = datesAndGuests.toDate.toDateString();
            selection.numberOfGuests = Math.min(datesAndGuests.guests, pbUnit.toGuests);
            selection.numberOfUnits = 1;
            selection.productRateId = rate.productRateId;
            selection.selectedUnit = pbUnit.vendorUnit;
            selection.travelPortRateName = selectedTravePortUnitName;
            selection.preBuiltPkgVendorUnit = pbUnit;

            addSelectedLodging(selection);
          }

          if (vendors[index].vendorType === "Golf") {
            const date = moment(datesAndGuests.fromDate).add(1 * (golfCount++), "days");
            const rate = outerRate.rates[0];

            let rateTeeTimes: TimeOption[] = [];
            let start = moment(rate.startTime, 'HH:mm');
            let end = moment(rate.endTime, 'HH:mm');

            // pbpkg stuffs
            const pkgStart = importedPackage.allowCustomization ? moment(pbUnit.fromTime, "HH:mm") : start;
            const pkgEnd = importedPackage.allowCustomization ? moment(pbUnit.toTime, "HH:mm") : end;

            if (rate.startTime !== rate.endTime)
              start.minutes(Math.ceil(start.minutes() / 10) * 10);

            let result: TimeOption[] = [];
            let current = moment(start);
            while (current <= end) {
              if (current >= pkgStart && current <= pkgEnd) {
                result.push({
                  value: current.format('HH:mm'),
                  label: current.format('hh:mm a') + (rate.isLive ? ` (${rate.openSpots} players) - Live` : ""),
                  openSpots: rate.openSpots,
                  foreUpTeeTimeId: rate.isLive ? rate.foreUpTeeTimeId : "",
                  golfNowTeeTimeId: rate.isLive ? rate.golfNowTeeTimeId : "",
                  lightSpeedTeeTimeId: rate.isLive ? rate.lightSpeedTeeTimeId : "",
                  price: rate.price,
                  vendorUnitId: rate.vendorUnitId,
                  productRateId: rate.productRateId,
                  isLive: rate.isLive
                });
              }

              current.add(10, 'minutes');
            }

            rateTeeTimes = rateTeeTimes.concat(result);

            if (!!rateTeeTimes.length) {
              rateTeeTimes = [...new Map(rateTeeTimes.map(item => [item.value, item])).values()] // Remove any cross-over duplicates.
            }

            rateTeeTimes.sort((a, b) => {
              // Sort by time.
              return moment(a.value, 'HH:mm').isBefore(moment(b.value, 'HH:mm')) ? -1 : 0;
            });

            let selection: GolfItem = { ...vendors[index] };
            selection.vendor = vendors[index];
            selection.vendorUnitId = pbUnit.vendorUnit.vendorUnitId;
            selection.startDate = date.isSameOrBefore(datesAndGuests.toDate) ? date.toDate().toDateString() : datesAndGuests.toDate.toDateString();
            selection.endDate = selection.startDate;
            selection.availableTimes = rateTeeTimes;
            selection.startTime = rateTeeTimes.length > 0 ? rateTeeTimes[0].value : "";
            // selection.guests = Math.min(datesAndGuests.guests, pbUnit.toGuests);
            selection.numberOfGuests = datesAndGuests.guests;
            // selection.useLocal = true;
            selection.productRateId = pbUnit.vendorUnit.productRateId;
            // selection.unitName = selectedUnitName as string;
            selection.foreUpTeeTimeId = "";
            selection.golfNowTeeTimeId = "";
            selection.lightSpeedTeeTimeId = "";
            selection.selectedUnit = pbUnit.vendorUnit;
            selection.preBuiltPkgVendorUnit = pbUnit;

            addSelectedGolf(selection);
          }
        }
      });
    }
  }, [calculateRateResponse.data]);

  // useEffect(() => {
  //   // console.log("brandId", brandId);
  // }, [brandId]);

  useEffect(() => {
    if (brandId === undefined || brandId === -1 || brandId === null) return;

    const brand = brands.find(b => b.brandId === brandId);
    if (brand === undefined) return;

    setBrand(brand);
    setCompanyId(brand.companyId);

    if (props.vendorGuid !== undefined)
      setGetVendorTypeByGuidRequest({ vendorGuid: props.vendorGuid });

    let fromDateString = datesAndGuests.fromDate ? datesAndGuests.fromDate.toLocaleDateString("en-US").replace("/", "-") : "";
    fromDateString = fromDateString.replace("/", "-");
    let toDateString = datesAndGuests.toDate ? datesAndGuests.toDate.toLocaleDateString("en-US").replace("/", "-") : "";
    toDateString = toDateString.replace("/", "-");
    setGetQuickPackagesRequest({ brandId, startDate: fromDateString, endDate: toDateString });
  }, [brandId, datesAndGuests]);

  useEffect(() => {
    if (responseGetQuickPackages.data) {
      let responseData: GetQuickPackagesResponse = responseGetQuickPackages.data;
      setPackages(responseData.packages);
    }
  }, [responseGetQuickPackages.data]);

  const [formKey, setFormKey] = useState<number>(12345);
  const [showForm, setShowForm] = useState<boolean>(true);
  useEffect(() => {
    setShowForm(!itineraryNotEmpty);
    setLoadingPackage(false);
  }, [itineraryNotEmpty]);

  useEffect(() => {
    setFormKey(formKey + 1);
  }, [showForm]);

  useEffect(() => {
    sendItineraryUnitsMessage();
  }, [show]);

  useEffect(() => {
    if (!!!responseGetVendorType.data) return;

    const vendorType = responseGetVendorType.data;
    setVendorGuidType(isStringEmpty(vendorType) ? undefined : vendorType);

    if (vendorType === "Lodging") {
      setShow("add-lodging")
    }
    if (vendorType === "Golf") {
      setShow("add-golf")
    }
    if (vendorType === "Transport") {
      setShow("add-transportation")
    }
    if (vendorType === "Custom") {
      setShow("add-custom")
    }
  }, [responseGetVendorType.data]);

  const [viewPackageDetails, setViewPackageDetails] = useState<any>();

  useEffect(() => {
    if (!!!getPackageByIdResponse.data) return;

    setPackageFromParam(getPackageByIdResponse.data.package);
    setViewPackageDetails(getPackageByIdResponse.data.package);
  }, [getPackageByIdResponse.data]);

  /*******************************************/

  return (
    <React.Fragment>
      {/* {responseGetWidget.isLoading || responseGetStyle.isLoading || responseGetBrands.isLoading || quoteSearchResponse.isLoading && ( */}
      {(isLoading || loadingPackage) && (
        <span><Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
          {!loadingPackage ? (<span> Loading...</span>) : (<span> Importing Package...</span>)}
        </span>
      )}

      {!loadingPackage && !!startWidget && !!style && brands.length > 0 && brandSettings.length > 0 && brand !== undefined && (
        <WidgetContext.Provider value={{
          companyId,
          // brandId,
          brandSettings,
          startWidget,
          style,
          datesAndGuests,
          fromEmail,
          viewPortWidth: width,
          viewPortHeight: height,
          viewPortBreakPoint: breakPoint,
          brand: brand,
          autoScroll: props.autoScroll,
          vendorGuid: props.vendorGuid,
          campaignId: (quote !== undefined ? quote.campaignId : undefined) || campaignId
        }}>
          {startWidget.active && (
            <>
              {/* {!fromEmail && ( */}
              {(!fromEmail && !!!quote) && (
                <>
                  {!itineraryNotEmpty && (
                    <Row className="mt-1 p-0">
                      <Col key={formKey}>
                        {/* Tab buttons */}
                        <Accordion defaultActiveKey={showForm ? "0" : undefined}>
                          {/* Desktop */}
                          {breakPoint >= ViewPort.md && (
                            <div className="d-flex justify-content-between tabs-bottom-border mb-3">
                              <Button
                                // className={`start-widget-tabs ${show == "build-your-own" || show == "" ? "selected" : ""}`}
                                className={`start-widget-tabs selected`}
                                // onClick={() => setShow("build-your-own")}
                                onClick={() => setShowForm(!showForm)}
                                style={{ color: style.linkColor }}
                              >
                                Build Package
                            </Button>

                              <Button
                                // className={`start-widget-tabs ${show == "package-specials" ? "selected" : ""}`}
                                className={`start-widget-tabs selected`}
                                onClick={() => setShow("package-specials")}
                                style={{ color: style.linkColor }}
                              >
                                View Specials
                            </Button>

                              <Button
                                // className={`start-widget-tabs ${show == "request-quote" ? "selected" : ""}`}
                                className={`start-widget-tabs selected`}
                                onClick={() => setShow("request-quote")}
                                style={{ color: style.linkColor }}
                              >
                                Request Quote
                            </Button>
                              <Button
                                // className={`start-widget-tabs ${show == "request-group-quote" ? "selected" : ""}`}
                                className={`start-widget-tabs selected`}
                                onClick={() => setShow("request-group-quote")}
                                style={{ color: style.linkColor }}
                              >
                                Request Group Quote
                            </Button>
                              <Button
                                // className={`start-widget-tabs ${show == "find-reservation" ? "selected" : ""}`}
                                className={`start-widget-tabs selected`}
                                onClick={() => setShow("find-reservation")}
                                style={{ color: style.linkColor }}
                              >
                                Find Quote
                            </Button>
                            </div>
                          )}

                          {/* Mobile */}
                          {breakPoint < ViewPort.md && (
                            <Row className="w-100 justify-content-center">
                              <MobileHamburgerMenu setShow={setShow} setShowForm={setShowForm} showForm={showForm} />
                            </Row>
                          )}

                          <Accordion.Collapse eventKey="0" className="mb-4">
                            <>
                              <WidgetForm
                                brands={brands}
                                datesAndGuestsState={[datesAndGuests, setDatesAndGuests]}
                                onSetBrandId={setBrandId}
                                onSetValidation={setValidated}
                                onWidgetButtonPressed={(button: string) => setShow(button)}
                                itineraryNotEmpty={itineraryNotEmpty}
                              />
                            </>
                          </Accordion.Collapse>
                        </Accordion>
                      </Col>
                    </Row>
                  )}

                  <div className="ml-1 d-none d-md-block">
                    <Row className="widget-form-buttons">
                      {startWidget.showLodgingButton && (importedPackage === undefined || importedPackage.allowCustomization ? true : false) && (
                        <Button
                          onClick={() => setShow(brandId !== undefined ? "add-lodging" : "")}
                          style={{
                            borderRadius: ".25rem",
                            backgroundColor: style.buttonColor,
                          }}
                        >
                          + Lodging
                        </Button>
                      )}
                      {startWidget.showGolfButton && (importedPackage === undefined || importedPackage.allowCustomization ? true : false) && (
                        <Button
                          onClick={() => setShow(brandId !== undefined ? "add-golf" : "")}
                          style={{
                            borderRadius: ".25rem",
                            backgroundColor: style.buttonColor,
                          }}
                        >
                          + Golf
                        </Button>
                      )}
                      {startWidget.showTransportationButton && (importedPackage === undefined || importedPackage.allowCustomization ? true : false) && (
                        <Button
                          onClick={() => setShow(brandId !== undefined ? "add-transportation" : "")}
                          style={{
                            fontSize: "14.75px",
                            borderRadius: ".25rem",
                            backgroundColor: style.buttonColor,
                          }}
                        >
                          + Transport
                        </Button>
                      )}
                      {startWidget.showExtrasButton && (importedPackage === undefined || importedPackage.allowCustomization ? true : false) && (
                        <Button
                          onClick={() => setShow(brandId !== undefined ? "add-custom" : "")}
                          style={{
                            borderRadius: ".25rem",
                            backgroundColor: style.buttonColor,
                          }}
                        >
                          + Extras
                        </Button>
                      )}
                    </Row>
                  </div>

                  {/* <Col xs={12} className="d-md-none justify-content-center m-0 p-0"> */}
                  <div className="d-flex d-md-none flex-column justify-content-center">
                    <Row className="">
                      {startWidget.showLodgingButton && (
                        <Col className="mobile-form-buttons">
                          <Button
                            type="submit"
                            onClick={() => setShow("add-lodging")}
                            style={{
                              borderRadius: ".25rem",
                              backgroundColor: style.buttonColor,
                              marginBottom: "15px",
                              border: "none",
                              width: "100%"
                            }}
                          >
                            + Lodging
                          </Button>
                        </Col>
                      )}
                      {startWidget.showGolfButton && (
                        <Col className="mobile-form-buttons">
                          <Button
                            type="submit"
                            onClick={() => setShow("add-golf")}
                            style={{
                              borderRadius: ".25rem",
                              backgroundColor: style.buttonColor,
                              marginBottom: "15px",
                              border: "none",
                              width: "100%"
                            }}
                          >
                            + Golf
                          </Button>
                        </Col>
                      )}
                      {startWidget.showTransportationButton && (
                        <Col className="mobile-form-buttons">
                          <Button
                            type="submit"
                            onClick={() => setShow("add-transportation")}
                            style={{
                              fontSize: "16.75px",
                              borderRadius: ".25rem",
                              backgroundColor: style.buttonColor,
                              marginBottom: "15px",
                              border: "none",
                              width: "100%"
                            }}
                          >
                            + Transport
                          </Button>
                        </Col>
                      )}
                      {startWidget.showExtrasButton && (
                        <Col className="mobile-form-buttons">
                          <Button
                            type="submit"
                            onClick={() => setShow("add-custom")}
                            style={{
                              borderRadius: ".25rem",
                              backgroundColor: style.buttonColor,
                              marginBottom: "15px",
                              border: "none",
                              width: "100%"
                            }}
                          >
                            + Extras
                          </Button>
                        </Col>
                      )}
                    </Row>
                  </div>
                  {/* {loadingPackage && (
                    <span className="font-italic text-dark"><Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    /> Importing Package...</span>
                  )} */}
                  {!loadingPackage && !itineraryNotEmpty && startWidget.showQuickPackages && packages.length > 0 && (
                    <>
                      <hr />

                      <h5 className="font-weight-bold" style={{ color: style.fontColor }}>Quick Packages</h5>

                      <Row className="w-100 mt-3 justify-content-space-between" style={{ height: "400px" }}>
                        {packages.map(pkg =>
                          <Col xs={12} md={3} xl={3} className="p-1">
                            <PackagesCard
                              key={`key`}
                              pbPackage={pkg}
                              onSelectedPackage={(pkg) => {
                                // validate selected dates against package dates
                                const validFrom = moment(pkg.validToTravelFrom).startOf('day').toDate();
                                const validTo = moment(pkg.validToTravelEnd).startOf('day').toDate();
                                
                                if (datesAndGuests.fromDate < validFrom || datesAndGuests.fromDate > validTo) {
                                  datesAndGuests.fromDate = validFrom;
                                }
                                if (datesAndGuests.toDate > validTo || datesAndGuests.toDate < validFrom) {
                                  datesAndGuests.toDate = validTo;
                                }
                                setDatesAndGuests({ ...datesAndGuests });
                                setViewPackageDetails(pkg); 
                              }}
                              stacked={true}
                              simpleView={false}
                            />
                          </Col>
                        )}
                      </Row>
                    </>
                  )}
                  {/* </Col> */}
                </>
              )}

              {/* Itinerary Start */}
              {itineraryNotEmpty && (
                <ItineraryStart
                  quoteState={[quote, setQuote]}
                  itineraryState={[itinerary, setItinerary]}
                  datesAndGuestsState={[datesAndGuests, setDatesAndGuests]}
                  sameDayReplays={undefined}
                  showState={[show, setShow]}
                  emailCustomer={emailCustomer}
                  pbPackage={importedPackage}

                  onEditLodging={(unit: LodgingItineraryUnit) => setLodgingItemToEdit(unit)}
                  onEditGolf={(unit: GolfItineraryUnit) => setGolfItemToEdit(unit)}
                  onEditTransport={(unit: TransportItineraryUnit) => setTransportItemToEdit(unit)}
                  onEditCustom={(unit: CustomItineraryUnit) => setCustomItemToEdit(unit)}
                />
              )}

              {/** Modals */}
              {/* Add Packages */}
              {brandId !== -1 && validated && show == "package-specials" && (
                <AddPreBuiltPackageModal
                  show={true}
                  onHide={() => setShow("build-your-own")}
                  brandId={brandId} // need brandID
                  datesAndGuestsState={[datesAndGuests, setDatesAndGuests]}
                  onSelectedPackage={pkg => setImportedPackage(pkg)}
                />
              )}

              {show == "request-quote" && (
                <RequestQuoteModal
                  show={true}
                  onHide={() => setShow("")}
                  datesAndGuests={datesAndGuests}
                />
              )}

              {show == "request-group-quote" && (
                <RequestQuoteModal
                  show={true}
                  onHide={() => setShow("")}
                  datesAndGuests={datesAndGuests}
                  isGroup
                />
              )}

              {show == "find-reservation" && (
                <FindReservationModal
                  show={true}
                  onHide={() => setShow("")}
                  handleSearchRequest={(email: string, itineraryNumber: string) => { setQuoteSearchRequest({ email, itineraryNumber }) }}
                />
              )}

              {/* Add Lodging */}
              {(brandId != undefined && validated && show === "add-lodging") && (
                <AddLodgingModal
                  show={true}
                  onHide={() => setShow("")}
                  brandId={brandId as number}
                  datesAndGuests={datesAndGuests}
                  unitToEditState={[lodgingItemToEdit, setLodgingItemToEdit]}
                  onSelectedLodging={(item: LodgingItem, index?: number) => {
                    // console.log("item", item);
                    setShow("");
                    addSelectedLodging(item, index);
                    setLodgingItemToEdit(undefined);
                  }}
                  vendorGuid={props.vendorGuid}
                  vendorGuidType={vendorGuidType}
                />
              )}

              {/* add golf vendor */}
              {brandId != undefined && validated && show === "add-golf" && (
                <AddGolfModal
                  show={true}
                  onHide={() => setShow("")}
                  brandId={brandId}
                  datesAndGuests={datesAndGuests}
                  unitToEditState={[golfItemToEdit, setGolfItemToEdit]}
                  onSelectedGolf={(item: GolfItem, index?: number) => {
                    setShow("");
                    addSelectedGolf(item, index);
                    setGolfItemToEdit(undefined);
                  }}
                  vendorGuid={props.vendorGuid}
                  vendorGuidType={vendorGuidType}
                // sameDayReplays={sameDayReplays}
                />
              )}

              {/* add transportation vendor */}
              {brandId != undefined && validated && show === "add-transportation" && (
                <AddTransportModal
                  show={true}
                  onHide={() => setShow("")}
                  brandId={brandId}
                  datesAndGuests={datesAndGuests}
                  onSelectedTransportation={(item: TransportItem, index?: number) => {
                    setShow("");
                    setTransportItemToEdit(undefined);
                    addSelectedTransportation(item, index);
                  }}
                  unitToEditState={[transportItemToEdit, setTransportItemToEdit]}
                  vendorGuid={props.vendorGuid}
                  vendorGuidType={vendorGuidType}
                />
              )}

              {/* add custom vendor */}
              {brandId != undefined && validated && show === "add-custom" && (
                <AddCustomModal
                  show={true}
                  onHide={() => setShow("")}
                  brandId={brandId}
                  datesAndGuests={datesAndGuests}
                  onSelectedCustom={(item: CustomItem, index?: number) => {
                    setShow("");
                    addSelectedCustom(item, index);
                    setCustomItemToEdit(undefined);
                  }}
                  unitToEditState={[customItemToEdit, setCustomItemToEdit]}
                  vendorGuid={props.vendorGuid}
                  vendorGuidType={vendorGuidType}
                />
              )}

              <PackageDetailsModal
                show={viewPackageDetails !== undefined}
                onHide={() => setViewPackageDetails(undefined)}
                pkg={viewPackageDetails}
                datesAndGuestsState={[datesAndGuests, setDatesAndGuests]}
                onSelectedPackage={pkg => setImportedPackage(pkg)}
              />
            </>
          )}
        </WidgetContext.Provider>
      )}
    </React.Fragment >
  );
}

export default Widget;